import { Controller } from "@hotwired/stimulus"

// Sets the fill width of an ingestion progress bar from a value.
// A script-driven style assignment is not subject to the CSP
// style-src directive, unlike an inline `style` attribute in markup.
export default class extends Controller {
  static values = { pct: Number }

  connect() {
    this.element.style.width = `${this.pctValue}%`
  }
}
